export class DocumentFormatsHelper {
    static shouldInsertNumbering(_model) {
        return true;
    }
    static shouldInsertMultiLevelNumbering(_model) {
        return true;
    }
}
